export default __webpack_public_path__ + "static/media/visitsGreen.36878dbf.png";